<template>
  <v-card v-if="!profileView || canDisplayAppointment" :disabled="loading" :class="profileView ? '' : 'lightBorder'" flat :style="{
    'background-color': backgroundColor,
    color: color,
  }"  @click="this.profileView ? getICS($event) : handleAppointmentClick($event)" @mousedown.middle="this.profileView ? getICS($event) : handleAppointmentClick($event)"
   >
    <v-container fluid>
      <v-row>
        <v-col>
          <b v-if="appointmentData.product">
            {{ appointmentData.product.name }}
          </b>
          <b v-else>
            {{ $t("messages.noProduct") }}
          </b>
        </v-col>
        <v-spacer />
        <v-col class="pb-0" cols="auto">
          {{ appointmentData.display_date }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-0 pt-0">
          {{ appointmentData.time_units[0].readable_start_time }} - {{
            appointmentData.time_units[this.appointmentData.time_units.length - 1].readable_end_time }} {{
            $t("basics.oClock") }}
        </v-col>
        <v-col  v-if="!disableDownload && profileView" 
         cols="auto" class="pa-0" style="display: flex; align-items: center;">
          <v-icon v-if="!downloaded" class="mr-2" color="primary"
            style="flex-grow: 1; font-size: 3em">mdi-download</v-icon>
          <v-icon v-else class="mr-2"  color="primary"
            style="flex-grow: 1; font-size: 3em">mdi-check</v-icon>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <div v-if="appointmentData.display_address">
            {{ appointmentData.display_address }}
          </div>
        </v-col>
      </v-row>
      <v-row v-if="profileView && !appointmentData.accepted_by_patient">
        <v-col class="pt-0" cols="12">
          <v-btn flat block large @click="acceptRequest" :loading="loading"
            style="background-color: rgb(var(--v-theme-primary)); color: rgb(var(--v-theme-background))"><v-icon
              size="x-large">mdi-check-all</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-row v-if="profileView">
        <v-col cols="12" class="pt-0"><small>{{ $t("messages.howToCancel") }}</small></v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";

export default {
  name: "appointmentCard",

  props: ["appointmentData", "profileView", "backofficeView", "disableDownload"],

  data() {
    return {
      backgroundColors: [
        "var(--v-theme-light-yellow)",
        "var(--v-theme-light-blue)",
        "var(--v-theme-light-green)"
      ],
      colors: [
        "rgba(var(--v-theme-primary), 1)",
        "rgba(var(--v-theme-secondary), 1)",
        "rgba(var(--v-theme-success), 1)"
      ],
      borders: [
        "rgba(var(--v-theme-yellow), 1)",
        "rgba(var(--v-theme-blue), 1)",
        "rgba(var(--v-theme-green), 1)"
      ],
      loading: false,
      downloaded: false,
    }
  },


  computed: {
    canDisplayAppointment() {
      const slot = this.appointmentData;
      if (!slot || slot.own_booking?.is_cancelled === true ||
          (slot.display_status && slot.display_status !== 'planned')) return false;
      return slot.public !== true || slot.own_booking?.is_paid === true;
    },
    computedTravelTimePrev() {
      if (!this.appointmentData || !this.appointmentData.travel_time_prev) {
        return 0
      }

      return appointmentData.travel_time_prev
    },
    computedTravelTimeAfter() {
      if (!this.appointmentData || !this.appointmentData.travel_time_after) {
        return 0
      }

      return appointmentData.travel_time_after
    },
    backgroundColor() {
      if (this.profileView) {
        return "rgba(var(--v-theme-light-yellow), 1)";
      }
      // if (this.errors && this.errors.length > 0) {
      //   return "rgba(var(--v-theme-red), 1)";
      // } 

      if (this.appointmentData.display_status != "planned") {
        return "rgba(var(--v-theme-background), 1)";
      }

      if (this.appointmentData.is_temporary) {
        return "rgba(var(--v-theme-background), 0.3)";
      }

      if (!this.appointmentData.accepted_by_patient) {
        return "rgba(" + this.backgroundColors[this.appointmentData.location] + ", 0.5)"
      }

      if (!this.appointmentData.accepted_by_therapist) {
        return "rgba(" + this.backgroundColors[this.appointmentData.location] + ", 0.5)"
      }

      if (this.appointmentData.location >= 0) {
        return "rgba(" + this.backgroundColors[this.appointmentData.location] + ", 1)"
      }


      return "rgba(var(--v-theme-background), 1)";
    },
    color() {
      if (this.profileView || this.backofficeView) {
        return "rgba(var(--v-theme-blue), 1)";
      }

      if (this.appointmentData.is_temporary || !this.appointmentData.id) {
        return "initial"
      }

      if (this.appointmentData.display_status != "planned") {
        return this.colors[this.appointmentData.location]
      }

      if (!this.appointmentData.accepted_by_patient) {
        return "initial";
      }
      if (!this.appointmentData.accepted_by_therapist) {
        return "initial";
      }

      if (this.appointmentData.location >= 0) {
        return this.colors[this.appointmentData.location]
      }


      return "initial"
    },
    border() {
      if (this.errors && this.errors.length > 0) {
        return "3px solid rgba(var(--v-theme-error), 1)";
      }

      if (this.appointmentData.display_status != "planned") {
        return "3px solid " + this.borders[this.appointmentData.location]
      }

      return "none";
    },
  },

  methods: {
    gotoCalendar(a) {
      if (!this.$checkFunctionPermission(["own_calendar_detail"])) {
        return
      }

      this.$router.push("/backoffice/calendar/own/?date=" + a.date + "&id=" + a.id)
    },
    gotoCalendarInNewTab(event, a) {
      event.stopPropagation()
      event.preventDefault()

      if (!this.$checkFunctionPermission(["own_calendar_detail"])) {
        return
      }

      this.$router.push("/backoffice/calendar/own/?date=" + a.date + "&id=" + a.id)
    },
    handleAppointmentClick() {
      if (!this.profileView) {
        this.gotoCalendar(this.appointmentData)
      } 
    },
    handleAppointmentMiddleClick(event) {
      if (!this.profileView) {
        gotoCalendarInNewTab(event, this.appointmentData)
      } 
    },
    getICS() {
      this.loading = true

      this.axios({
        method: "POST",
        url: this.axios.defaults.baseURL + "calendar/ical/icsfile/",
        responseType: "blob", // Important! Set the response type to 'blob' for binary data
        data: {
          id: this.appointmentData.id,
        },
      })
        .then(async (resp) => {
          if (Capacitor.isNativePlatform()) {
            const contentDisposition = resp.headers?.["content-disposition"] || "";
            const match = /filename="?([^"]+)"?/.exec(contentDisposition);
            const filename = match?.[1] || `Termin-${this.appointmentData.display_date}.ics`;
            const icsText = typeof resp.data === "string" ? resp.data : String(resp.data ?? "");
            
            const path = `Keilberg/${filename}`;

            const isIOS = Capacitor.getPlatform() == 'ios'

            await Filesystem.writeFile({
              directory: isIOS ? Directory.Cache : Directory.Documents,
              path: path,
              recursive: true,
              data: icsText,
              encoding: Encoding.UTF8
            });

            
            if(isIOS){
              const uriResult = await Filesystem.getUri({ directory: isIOS ? Directory.Cache : Directory.Documents, path: path });
              
              await Share.share({
                url: uriResult.uri,
                title: "Datei teilen oder speichern",
                dialogTitle: "Datei teilen oder speichern",
              })
            } else {
              // android not possible to choose custom download location
              // all possibilities https://capacitorjs.com/docs/apis/filesystem#directory
              
              this.downloaded = true
              setTimeout(()=>{
                this.downloaded = false
              }, 3000)
            }
          } else {
            const href = URL.createObjectURL(resp.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            const contentDisposition = resp.headers["content-disposition"];
            const filenameMatch = /filename=([^"]+)/.exec(contentDisposition);
            console.log(filenameMatch)
            link.setAttribute('download', filenameMatch[filenameMatch.length - 1]); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          }

          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    denyRequest(event) {
      event.stopPropagation()
      event.preventDefault()


      let formData = {
        id: this.appointmentData.id
      }

      this.axios
        .patch(this.axios.defaults.baseURL + "calendar/timeslots/patients/deny/", formData)
        .then((resp) => {
          this.$emit("refetch")
          this.loading = false
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          this.loading = false
        });
    },
    acceptRequest(event) {
      event.stopPropagation()
      event.preventDefault()

      this.loading = true

      let formData = {
        id: this.appointmentData.id,
        accepted_by_patient: true
      }

      this.axios
        .patch(this.axios.defaults.baseURL + "calendar/timeslots/patients/accept/", formData)
        .then((resp) => {
          this.$emit("refetch")
          this.loading = false
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          this.loading = false
        });
    },
  },
};
</script>
